import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importing translation objects from JS files
import csCZTranslation from './cs-CZ-translations';
import daDKTranslation from './da-DK-translations';
import deATTranslation from './de-AT-translations';
import deDETranslation from './de-DE-translations';
import deCHTranslation from './de-CH-translations';
import enAUTranslation from './en-AU-translations';
import enCATranslation from './en-CA-translations';
import enGBTranslation from './en-GB-translations';
import enIETranslation from './en-IE-translations';
import enNZTranslation from './en-NZ-translations';
import enUSTranslation from './en-US-translations';
import esESTranslation from './es-ES-translations';
import fiFITranslation from './fi-FI-translations';
import frBETranslation from './fr-BE-translations';
import frCHTranslation from './fr-CH-translations';
import frFRTranslation from './fr-FR-translations';
import huHUTranslation from './hu-HU-translations';
import itCHTranslation from './it-CH-translations';
import itITTranslation from './it-IT-translations';
import nlBETranslation from './nl-BE-translations';
import nlNLTranslation from './nl-NL-translations';
import nnNOTranslation from './nn-NO-translations';
import ptPTTranslation from './pt-PT-translations';
import skSKTranslation from './sk-SK-translations';
import svSETranslation from './sv-SE-translations';

i18n
  .use(LanguageDetector)  // Automatically detects user language
  .use(initReactI18next) 
  .init({
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'ui_locales',
    },
    resources: {
      "cs-CZ": {
          "translation": csCZTranslation
      },
      "da-DK": {
          "translation": daDKTranslation
      },
      "de-AT": {
          "translation": deATTranslation
      },
      "de-CH": {
          "translation": deCHTranslation
      },
      "de-DE": {
          "translation": deDETranslation
      },
      "en-AU": {
          "translation": enAUTranslation
      },
      "en-CA": {
          "translation": enCATranslation
      },
      "en-GB": {
          "translation": enGBTranslation
      },
      "en-IE": {
          "translation": enIETranslation
      },
      "en-NZ": {
          "translation": enNZTranslation
      },
      "en-US": {
          "translation": enUSTranslation
      },
      "es-ES": {
          "translation": esESTranslation
      },
      "fi-FI": {
          "translation": fiFITranslation
      },
      "fr-BE": {
          "translation": frBETranslation
      },
      "fr-CH": {
          "translation": frCHTranslation
      },
      "fr-FR": {
          "translation": frFRTranslation
      },
      "hu-HU": {
          "translation": huHUTranslation
      },
      "it-CH": {
          "translation": itCHTranslation
      },
      "it-IT": {
          "translation": itITTranslation
      },
      "nl-BE": {
          "translation": nlBETranslation
      },
      "nl-NL": {
          "translation": nlNLTranslation
      },
      "nn-NO": {
          "translation": nnNOTranslation
      },
      "pt-PT": {
          "translation": ptPTTranslation
      },
      "sk-SK": {
          "translation": skSKTranslation
      },
      "sv-SE": {
          "translation": svSETranslation
      }
  },
    fallbackLng: 'en-IE',  // Default language if detection fails
    interpolation: {
      escapeValue: false, // React already protects against XSS
    },
  });

export default i18n;